export const BOOTCAMP_TABS = {
  MODULES: "Assignments",
  CURRICULUM: "Curriculum",
  TASKS: "Daily Tasks",
}

export const BOOTCAMP_STEPS = {
  PANEL: "PANEL",
  MODULE: "MODULE",
  CURRICULUM: "CURRICULUM",
}

export const BOOTCAMP_MODULE_TYPES = {
  ENTRY: "ENTRY",
  QUESTION: "QUESTION",
}



// WEBPACK FOOTER //
// ./src/store/bootcamp/bootcamp.constants.js